<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.SourceCurrency')" prop="sourceCurrency">
            <BjInput v-model="queryParams.sourceCurrency" :placeholder="$t('QuotationCustomerLang.SourceCurrency')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCustomerLang.TargetCurrency')" prop="targetCurrency">
            <BjInput v-model="queryParams.targetCurrency" :placeholder="$t('QuotationCustomerLang.TargetCurrency')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <el-table-column
          v-for="(col, index) in dropCols"
          :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
          :prop="col.prop"
          :label="col.label"
          :width="col.width || 'auto'"
          :fixed="col.fixed || false"
          align="center"
          class-name="item"
        >
          <template slot-scope="scope">
            <template v-if="col.prop === 'effectiveFrom' || col.prop === 'effectiveTo'">
              {{ scope.row[col.prop] | timeFilters({ dateFormat: 'DD/MM/YYYY' }) }}
            </template>
            <template v-else-if="col.prop === 'status'">
              <el-tag :type="scope.row[col.prop] == 1 ? 'success' : 'info'">
                {{ $t(STATUS_ENABLED_NUM.bjGet(scope.row[col.prop])) }}
              </el-tag>
            </template>
            <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
          </template>
        </el-table-column>
      </template>
    </BjPage>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
import pageMiXin from '@/utils/page-mixin.js';

export default {
  name: 'SettingBaseDataExchangeRateIndex',
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      colSpan: 4,
      serial: true,
      selection: false,
      queryApi: logisticApi.getExchangeRates,
      queryParams: {
        sourceCurrency: null,
        targetCurrency: null,
      },
      labelList: [
        { label: 'QuotationCustomerLang.SourceCurrency', prop: 'sourceCurrency', isCheck: true, disabled: false },
        { label: 'QuotationCustomerLang.TargetCurrency', prop: 'targetCurrency', isCheck: true, disabled: false },
        { label: 'QuotationCustomerLang.ExchangeRate', prop: 'exchangeRate', isCheck: true, disabled: false },
        { label: 'QuotationCustomerLang.StartTime', prop: 'effectiveFrom', isCheck: true, disabled: false },
        { label: 'QuotationCustomerLang.EndTime', prop: 'effectiveTo', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
      ],
    };
  },
};
</script>
